import React from 'react';
import PropTypes from 'prop-types';
import ReactStars from 'react-rating-stars-component';
import PictionJS from 'piction-js';
import classNames from 'classnames';
import { updateUMORating } from '../../actions/umo';

function UMOGridNoJItem({ umo, ratingsConfig, dispatch }) {
  const onRatingUpdate = (newRating) => {
    dispatch(updateUMORating(umo.id, newRating));
  };

  const ratingTag = umo.metadataList.getMetadata(
    ratingsConfig.overrideMetatag
      ? ratingsConfig.overrideMetatag
      : 'INTERNAL.RATING'
  );
  let currentRating = 0;
  if (ratingTag && ratingTag.value) currentRating = parseInt(ratingTag.value);

  return (
    <div className={classNames('umo-grid-item-ratings')}>
      <ReactStars
        className="umo-grid-item-ratings-stars"
        value={currentRating}
        onChange={onRatingUpdate}
        count={5}
        size={17}
        edit={ratingsConfig.complex}
        half={false}
        emptyIcon={<i className="fas fa-star" />}
        filledIcon={<i className="fas fa-star" />}
        color2={'#5e2064'}
      />
    </div>
  );
}

UMOGridNoJItem.propTypes = {
  umo: PropTypes.instanceOf(PictionJS.UMO).isRequired,
  ratingsConfig: PropTypes.object.isRequired,
  dispatch: PropTypes.func,
};

export default UMOGridNoJItem;
